import {BasePage} from '../utils/base';
import {getMonkey} from '../utils/monkeys';
import '../css/password.scss';

export class PasswordPage extends BasePage {
  view: HTMLElement;
  codeInput: HTMLInputElement;
  button: HTMLElement;

  monkeyClose;
  monkeyPeek;

  disabled: boolean = false;
  hidePassword: boolean = true;

  constructor() {
    super();

    let submit = () => {
      if (this.disabled) {
        return;
      }

      this.disabled = true;
      this.codeInput.classList.add('disabled');
      this.button.classList.add('loading');

      this.apiHelper.setPassword(this.codeInput.value).catch(() => {
        this.disabled = false;

        this.codeInput.classList.remove('disabled');
        this.codeInput.classList.add('wrong');
        this.button.classList.remove('loading');
      });
    };

    let viewTemplate = this.templates.querySelector('.password') as HTMLElement;
    this.setPage(viewTemplate.cloneNode(true) as HTMLElement);

    this.view = this.app.querySelector('.password') as HTMLElement;

    this.codeInput = this.view.querySelector('input') as HTMLInputElement;

    this.codeInput.addEventListener('keydown', this.codeKeyDown);
    this.codeInput.addEventListener('keyup', this.codeChange);
    this.codeInput.addEventListener('keypress', event => {
      if (event.keyCode == 13) {
        submit();
      }
    });

    let logo = this.view.querySelector('.logo') as HTMLElement;

    this.monkeyClose = getMonkey(0).cloneNode(true);
    this.monkeyClose.setAttribute('autoplay', 'true');

    this.monkeyClose.addEventListener('frame', event => {
      if (event.detail.seeker > 50) {
        this.monkeyClose.style.display = 'none';
        this.monkeyPeek.style.display = 'block';
      }
    });

    logo.appendChild(this.monkeyClose);

    this.monkeyPeek = getMonkey(4).cloneNode(true);
    this.monkeyPeek.style.display = 'none';

    this.monkeyPeek.addEventListener('frame', event => {
      if (event.detail.seeker > 50) {
        this.monkeyPeek.pause();
      }
    });

    logo.appendChild(this.monkeyPeek);

    this.button = this.view.querySelector('button') as HTMLElement;
    this.addLoading('.button-loading', this.button);

    this.button.addEventListener('click', submit);

    let yeyIcon = this.view.querySelector('.eye-icon') as HTMLElement;
    yeyIcon.addEventListener('click', () => {
      this.hidePassword = !this.hidePassword;
      if (!this.hidePassword) {
        yeyIcon.classList.add('show');

        this.monkeyPeek.setDirection(1);
        this.monkeyPeek.seek('0%');
        this.monkeyPeek.play();

        this.codeInput.type = 'text';
      } else {
        yeyIcon.classList.remove('show');

        this.monkeyPeek.setDirection(-1);
        this.monkeyPeek.play();

        this.codeInput.type = 'password';
      }
    });

    requestAnimationFrame(() => {
      this.codeInput.focus();
    });
  }

  codeKeyDown = (event: KeyboardEvent) => {
    if (this.disabled) {
      event.preventDefault();
    }
  };

  codeChange = () => {
    if (this.disabled) {
      return;
    }

    let password = this.codeInput.value;
    if (password) {
      this.codeInput.classList.add('value');
    } else {
      this.codeInput.classList.remove('value');
      this.codeInput.classList.remove('wrong');
    }
  };
}
